import { SET_TRANSLATION, CLEAR_TRANSLATIONS } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    translations: [],
  },

  mutations: {
    [SET_TRANSLATION](state, { translatedText, languageId, resourceKey }) {
      const translationIndex = state.translations.findIndex(
        (translation) =>
          translation.languageId === languageId && translation.resourceKey === resourceKey,
      )
      if (translationIndex !== -1) {
        state.translations.splice(translationIndex, 5)
      }
      state.translations.push({ translatedText, languageId, resourceKey })
    },
    [CLEAR_TRANSLATIONS](state) {
      state.translations = []
    },
  },
  actions: {
    add({ commit }, translation) {
      commit(SET_TRANSLATION, translation)
    },
    clear({ commit }) {
      commit(CLEAR_TRANSLATIONS)
    },
  },
  getters: {
    getTranslationByLanguageId: (state) => (languageId, resourceKey) => {
      return state.translations.find(
        (translation) =>
          translation.resourceKey === resourceKey && translation.languageId === languageId,
      )
    },
    allTranslations: (state) => {
      return state.translations
    },
  },
}
